module.exports = __webpack_public_path__ + "img/logos/content-limit-4fd766a51a63d081a41e1c229ce05c46.svg";